import React, { useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Input, Layout, Select } from '../../../components';
import { useToast } from '../../../hooks/toast';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import type { ScreenData } from '../../../shared/interfaces/screen';
import getValidationErrors from '../../../utils/getValidationErrors';
import icons from '../icons';
import urls from '../urls';
import { Container, FormContainer, FormFooter } from './styles';

const Telas: React.FC = () => {
  const formRef = useRef<FormHandles | null>(null);
  const history = useHistory();
  const { addToast } = useToast();
  let selectedIcon: any;
  let selectedURL: any;

  const handleSubmit = useCallback(async (data: ScreenData) => {
    try {
      const schema = Yup.object().shape({
        icone: Yup.string().required('Este campo é obrigatório!'),
        titulo: Yup.string()
          .max(40, 'No máximo 40 caracteres')
          .required('Este campo é obrigatório!'),
        subtitulo: Yup.string()
          .max(40, 'No máximo 40 caracteres')
          .required('Este campo é obrigatório!'),
        url: Yup.string().required('Este campo é obrigatório!'),
      });
      data.icone = selectedIcon;
      data.url = selectedURL;
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/tela', data);

      addToast({
        type: 'success',
        title: 'Tela cadastrado com sucesso!',
        description:
          'As informações da Tela foram cadastradas. Você pode verificar a nova Tela na seção de Listagem de Telas.',
      });

      setTimeout(() => {
        history.push(RoutesPaths.listScreen);
      }, 4000);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errorMessages = getValidationErrors(err);
        formRef.current?.setErrors(errorMessages);
        return;
      } else {
        console.error(err);
        addToast({
          type: 'error',
          title: 'Tela já cadastrada!',
          description:
            'As informações que foram inseridas, já estão presentes no sistema.',
        });
      }
    }
  }, []);

  return (
    <Layout title={'Cadastro de Telas'} hideFloatingButton>
      <Container>
        <FormContainer>
          <Form
            className="form-container"
            ref={formRef}
            onSubmit={handleSubmit}
          >
            <Input name="titulo" label="Título" type="text" />
            <Input name="subtitulo" label="Subtítulo" type="text" />
            <Select
              name={'icone'}
              isMulti={false}
              options={icons}
              onChange={option => (selectedIcon = option.value)}
              placeholder="Selecione"
              label="Ícone"
              loading={!icons.length ? true : false}
            />
            <br></br>
            <Select
              name={'url'}
              isMulti={false}
              options={urls}
              onChange={option => (selectedURL = option.value)}
              placeholder="Selecione"
              label="URL"
              loading={!urls.length ? true : false}
            />

            <FormFooter>
              <Button
                variant="solid"
                style={{ marginTop: '1rem' }}
                type="submit"
              >
                Cadastrar
              </Button>
            </FormFooter>
          </Form>
        </FormContainer>
      </Container>
    </Layout>
  );
};

export default Telas;
